export function generateSnippet(content, query, radius = 100) {
	content = content.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

	// Strip HTML tags and normalize whitespace
	const text = content
		.replace(/<\/?[^>]+(>|$)/g, '')
		.replace(/\s+/g, ' ')
		.trim();

	const lowerQuery = query.toLowerCase();
	const lowerText = text.toLowerCase();
	const index = lowerText.indexOf(lowerQuery);

	if (index === -1) return '';

	const startRaw = Math.max(0, index - radius);
	const endRaw = Math.min(text.length, index + query.length + radius);

	// Trim to whole words
	const start = text.lastIndexOf(' ', startRaw);
	const end = text.indexOf(' ', endRaw);
	const snippet = text
		.slice(start === -1 ? 0 : start + 1, end === -1 ? text.length : end)
		.trim();

	return snippet + '...';
}

export function highlightQuery(snippet, query) {
	if (!query || !snippet) return snippet;

	const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	const regex = new RegExp(escapedQuery, 'i');

	return snippet.replace(
		regex,
		(match) => `<span class="highlighted">${match}</span>`
	);
}

export function getSessionId() {
	let id = localStorage.getItem('session_id');
	if (!id) {
		id = crypto.randomUUID();
		localStorage.setItem('session_id', id);
	}
	return id;
}

export const programKeywords = [
	'acute',
	'admin',
	'administration',
	'adn',
	'adult',
	'associate',
	'assistant',
	'bachelor\'s',
	'bachelors',
	'bha',
	'bs',
	'bsn',
	'business',
	'care',
	'clinical',
	'counseling',
	'degree',
	'dental',
	'dnp',
	'doctor',
	'doctoral',
	'doctorate',
	'dpt',
	'dr',
	'educator',
	'family',
	'gerontology',
	'graduate',
	'health',
	'hygiene',
	'in',
	'language',
	'leader',
	'lpn',
	'lvn',
	'master',
	'masters',
	'master\'s',
	'master',
	'mental',
	'mba',
	'mha',
	'mpa',
	'mph',
	'ms',
	'msn',
	'mslp',
	'msot',
	'nurse',
	'nursing',
	'occupational',
	'of',
	'otd',
	'online',
	'pathology',
	'pharmd',
	'pharmacy',
	'physician',
	'practice',
	'practitioner',
	'programs',
	'psychiatric',
	'public',
	'registered',
	'rn',
	'speech',
	'undergraduate',
	'therapy',
];

export function sortProgramQuery(url) {
	if (url.paths.path_1 === 'programs' || url.paths.path_1 === 'online-programs')
		if (!url.paths.path_3) {
			return 0;
		} else {
			return 1;
		}
	if (url.paths.path_1 === 'campuses') return 2;
	if (url.paths.path_1 === 'blog') return 4;
	if (url.paths.path_1 === 'glossary') return 5;
	return 3;
}

export const campusKeywords = [
	'campus',
	'campuses',
	'cgs',
	'center for graduate studies',
	'dallas',
	'fl',
	'florida',
	'la',
	'los angeles',
	'miami',
	'oc',
	'ontario',
	'orange county',
	'richardson',
	'texas',
	'tx',
];

export function sortCampusQuery(url) {
	if (url.paths.path_1 === 'campuses') return 0;
	if (url.paths.path_1 === 'programs' || url.paths.path_1 === 'online-programs')
		return 1;
	if (url.paths.path_1 === 'blog') return 3;
	if (url.paths.path_1 === 'glossary') return 4;
	return 2;
}

export async function fetchQuerySuggestions(pb, school) {
	try {
		const pbResponse = await pb
			.collection(`${school}_query_suggestions`)
			.getFullList();
		console.log('pbResponse = ', pbResponse);

		return pbResponse;
	} catch (err) {
		console.error(
			'PocketBase is unreachable or returned an error:',
			err.message
		);
	}
}

function formatToPlainEnglish(str, isCourse = false) {
	const lowercaseWords = ['and', 'of', 'by'];
	let words = str.replace(/^\//, '').split('-');
	words = words.map((word, index) =>
		lowercaseWords.includes(word.toLowerCase()) && index !== 0
			? word.toLowerCase()
			: word.charAt(0).toUpperCase() + word.slice(1)
	);
	if (isCourse) words.shift();
	return words.join(' ');
}

export function parseHitTypeWcuDotEdu(hit) {
	if (
		hit.url.paths.path_1 === 'online-programs' ||
		hit.url.paths.path_1 === 'programs'
	)
		return 'Programs';
	if (hit.post_type === 'post') return 'Blog';
	if (!hit.url.paths.path_2) return '';
	let hitType = formatToPlainEnglish(hit.url.paths.path_1);
	if (hitType === 'Tuition Financial Aid') hitType = 'Tuition & Financial Aid';
	return hitType;
}

export function parseHitTypeCatalog(hit) {
	if (hit.url.paths.path_4) {
		let hitType = formatToPlainEnglish(hit.url.paths.path_4);
		if (hitType === 'Faculty by Location' && hit.url.paths.path_5) {
			hitType += ` - ${formatToPlainEnglish(hit.url.paths.path_5)}`;
		} else if (hitType === 'Courses' && hit.url.paths.path_5) {
			hitType += ` - ${formatToPlainEnglish(hit.url.paths.path_5, true)}`;
		}
		return hitType;
	}
	return 'Catalog';
}
